import {
  MapDataKind,
  type PostingDiscoveryGeoData,
} from '@revelio/data-access';

import { LocationType, type MapPoint } from '../../Chart/Map/types';

export const transformPostingDiscoveryMapData = (
  rawMapData: (PostingDiscoveryGeoData | null | undefined)[] | null | undefined
): MapPoint[] => {
  const result =
    rawMapData
      ?.map((d) => {
        if (!d || !d.lat || !d.lon) return null;
        let locationType: LocationType | null = null;

        if (d.map_data_kind === MapDataKind.City) {
          locationType = LocationType.CITY;
        } else if (d.map_data_kind === MapDataKind.Country) {
          locationType = LocationType.COUNTRY;
        } else if (d.map_data_kind === MapDataKind.Msa) {
          locationType = LocationType.METRO_AREA;
        } else if (d.map_data_kind === MapDataKind.State) {
          locationType = LocationType.STATE;
        }

        return {
          id: String(d.id),
          label: d.location,
          lat: d.lat,
          lon: d.lon,
          value: d.count ?? 0,
          locationType,
          tooltip: { type: d.map_data_kind, id: d.id },
        } as MapPoint;
      })
      .filter((p): p is MapPoint => p !== null) ?? [];

  return result;
};
